export function getWindowHostname(): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return window?.location?.hostname;
}
